<script setup="">
import { CircleHelpIcon } from "lucide-vue-next";
import { computed, inject } from "vue";

const props = defineProps({
  defaultClass: {
    type: String,
    required: false,
    default: "flex items-center justify-between text-700 text-sm tracking-tight"
  },
  classes: {
    type: String,
    required: false
  },
  tooltip: {
    type: String,
    required: false
  },
  required: {
    type: Boolean,
    required: false,
    default: true
  }
});

const twMerge = inject("twMerge");
const computedClass = computed(() => twMerge(props.defaultClass, props.classes));
</script>

<template>
  <div v-bind="$attrs" :class="computedClass">
    <span>
      <slot />

      <strong v-if="!required" class="pl-1 text-xs font-normal text-400">(선택)</strong>
    </span>
    <span>
      <CircleHelpIcon v-if="tooltip" v-tippy="{ content: tooltip, interactive: false }" role="tooltip" class="h-4 w-4 text-400" tabindex="-1" />
    </span>
  </div>
</template>
